import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  panelBgColor: 'var(--color-white)',
  panelTitleTextColor: 'var(--color-primary)',
  panelContentTextColor: 'var(--color-text)',
  activePanelBgColor: 'var(--color-greyLight)',
  activactivePanelTitleTextColor: 'var(--color-primary)',
  activePanelContentTextColor: 'var(--color-text)',
  activePanelContentBackgroundColor: 'var(--color-white)',
	items: [
    {
      id: 'sample-item',
      title: 'Images made for you', 
      content: 'With some optional subtext',
      image: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9'
    }
  ]
}
 